(() => {
  const root = document.querySelector('[data-aelein-product-hero]');
  if (!root) return;

  const sectionId = root.dataset.sectionId;
  const jsonEl = document.getElementById(`AeleinHeroJson-${sectionId}`);
  if (!jsonEl) return;

  let data;
  try {
    data = JSON.parse(jsonEl.textContent);
  } catch {
    return;
  }

  const img = root.querySelector('[data-aelein-hero-main-img]');
  const desktopPrimaryImg = root.querySelector('[data-aelein-hero-gallery-primary]');
  const priceEl = root.querySelector('[data-aelein-hero-price]');
  const variantInput = root.querySelector('[data-aelein-hero-variant-id]');
  const submitBtn = root.querySelector('[data-aelein-hero-submit]');
  const submitLabel = root.querySelector('[data-aelein-hero-submit-label]');
  const counterCurr = root.querySelector('[data-aelein-hero-counter-curr]');
  const counterTotal = root.querySelector('[data-aelein-hero-counter-total]');
  const thumbs = root.querySelectorAll('[data-aelein-hero-thumb]');
  const finishRadios = root.querySelectorAll('[data-aelein-hero-finish-radio]');
  const quoteUrl = root.querySelector('.aelein-product-hero__quote-btn')?.href || '/pages/request-a-quote';

  function enforceQuoteCta() {
    if (!submitBtn || !submitLabel) return;

    submitBtn.removeAttribute('disabled');
    submitBtn.removeAttribute('aria-disabled');
    submitLabel.textContent = 'Request Quote';

    if (submitBtn.tagName === 'BUTTON') {
      submitBtn.type = 'button';
      if (!submitBtn.dataset.aeleinQuoteBound) {
        submitBtn.dataset.aeleinQuoteBound = 'true';
        submitBtn.addEventListener('click', (event) => {
          event.preventDefault();
          window.location.href = quoteUrl;
        });
      }
    }

    const form = submitBtn.closest('form');
    if (form && !form.dataset.aeleinQuoteBound) {
      form.dataset.aeleinQuoteBound = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        window.location.href = quoteUrl;
      });
    }
  }

  enforceQuoteCta();

  const padIndex = (idx) => {
    const n = idx + 1;
    return n < 10 ? `0${n}` : String(n);
  };

  const padTotal = (total) => (total < 10 ? `0${total}` : String(total));

  function updateCounter(idx, total) {
    if (!counterCurr || !counterTotal || !total) return;
    counterCurr.textContent = padIndex(idx);
    counterTotal.textContent = padTotal(total);
  }

  function setThumbActive(idx) {
    thumbs.forEach((t) => {
      const i = Number(t.dataset.mediaIndex);
      const on = i === idx;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function applyMediaIndex(idx) {
    const m = data.media[idx];
    if (!m || !img) return;
    img.src = m.src;
    setThumbActive(idx);
    updateCounter(idx, data.media.length);
  }

  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      const idx = Number(btn.dataset.mediaIndex);
      applyMediaIndex(idx);
    });
  });

  function findVariant(finishValue) {
    const fi = data.finishOptionIndex;
    if (fi === null || fi === undefined) {
      return data.variants.find((v) => v.id === data.selectedVariantId) || data.variants[0];
    }

    const optsMatch = (v, finishVal) => {
      const o = [v.option1, v.option2, v.option3];
      if (o[fi] !== finishVal) return false;
      return data.optionLocks.every((lock, i) => {
        if (i === fi) return true;
        if (lock == null || lock === '') return true;
        return o[i] === lock;
      });
    };

    return (
      data.variants.find((v) => optsMatch(v, finishValue) && v.available) ||
      data.variants.find((v) => optsMatch(v, finishValue)) ||
      data.variants.find((v) => {
        const o = [v.option1, v.option2, v.option3];
        return o[fi] === finishValue && v.available;
      }) ||
      data.variants.find((v) => {
        const o = [v.option1, v.option2, v.option3];
        return o[fi] === finishValue;
      })
    );
  }

  function applyVariant(v) {
    if (!v || !priceEl) return;

    data.selectedVariantId = v.id;
    if (variantInput) {
      variantInput.value = String(v.id);
    }
    priceEl.textContent = v.price_money;

    if (v.featured_src) {
      if (img) {
        img.src = v.featured_src;
      }
      if (desktopPrimaryImg) {
        desktopPrimaryImg.src = v.featured_src;
      }
      const midx = data.media.findIndex((m) => m.id === v.featured_media_id);
      if (midx >= 0) {
        setThumbActive(midx);
        updateCounter(midx, data.media.length);
      }
    }

    if (submitBtn && submitLabel) {
      enforceQuoteCta();
    }

    const base = (data.productUrl || '').split('?')[0];
    if (base && typeof history !== 'undefined' && history.replaceState) {
      history.replaceState({}, '', `${base}?variant=${v.id}`);
    }
  }

  finishRadios.forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!radio.checked || radio.disabled) return;
      const v = findVariant(radio.value);
      applyVariant(v);
    });
  });

  if (data.media && data.media.length > 0 && counterCurr && counterTotal) {
    const sv = data.variants.find((v) => v.id === data.selectedVariantId);
    let idx = 0;
    if (sv && sv.featured_media_id != null) {
      const found = data.media.findIndex((m) => m.id === sv.featured_media_id);
      if (found >= 0) idx = found;
    }
    updateCounter(idx, data.media.length);
  }

  const stage = root.querySelector('.aelein-product-hero__stage');
  function syncStageHeight() {
    if (!stage) return;
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    if (!desktop) {
      root.style.removeProperty('--ae-stage-height');
      return;
    }
    root.style.setProperty('--ae-stage-height', `${Math.round(stage.getBoundingClientRect().height)}px`);
  }

  syncStageHeight();
  window.addEventListener('resize', syncStageHeight);
  window.matchMedia('(min-width: 990px)').addEventListener('change', syncStageHeight);
  if (typeof ResizeObserver !== 'undefined' && stage) {
    new ResizeObserver(() => syncStageHeight()).observe(stage);
  }
  if (img) {
    img.addEventListener('load', syncStageHeight);
  }
})();
